<template>
	<v-container class="container--narrow">
		<v-card>
			<v-card-text>
				<SchemaToForm
					v-model="formData"
					:schema="formSchema"
					:disabled="formLoading"
					@valid="formValid = true"
					@invalid="formValid = false"
				/>
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-spacer />
				<v-btn
					color="primary"
					:loading="formLoading"
					:disabled="formLoading || !formValid"
					@click="save"
					text
				>
					{{ $i18n.t('general.save') }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
	name: 'CompensationForm',

	data: () => ({
		formSchema: {},
		formData: {
			c_support: 'hoitokorvaus',
		},
		formLoading: false,
		formValid: true,
	}),

	computed: {
		...mapState({
			config: state => state.config,
			user: state => state.user,
		}),
	},

	watch: {
		formData: {
			handler (val) {
				const fieldsToToggle = {
					'startdate': this.formSchema.fields.findIndex(item => item.name === 'startdate'),
					'enddate': this.formSchema.fields.findIndex(item => item.name === 'enddate'),
					'c_agerange': this.formSchema.fields.findIndex(item => item.name === 'c_agerange'),
					'c_illness_date': this.formSchema.fields.findIndex(item => item.name === 'c_illness_date'),
					'_c_support_ensiavustus_extra_details': this.formSchema.fields.findIndex(item => item.name === '_c_support_ensiavustus_extra_details'),
					'_c_support_hoitokorvaus_extra_details': this.formSchema.fields.findIndex(item => item.name === '_c_support_hoitokorvaus_extra_details'),
				}

				if(val.c_support === 'ensiavustus') {
					// hidden
					this.$set(this.formSchema.fields[fieldsToToggle.startdate], 'hidden', true)
					this.$set(this.formSchema.fields[fieldsToToggle.enddate], 'hidden', true)
					this.$set(this.formSchema.fields[fieldsToToggle._c_support_hoitokorvaus_extra_details], 'hidden', true)

					// visible
					this.$set(this.formSchema.fields[fieldsToToggle.c_agerange], 'hidden', false)
					this.$set(this.formSchema.fields[fieldsToToggle.c_illness_date], 'hidden', false)
					this.$set(this.formSchema.fields[fieldsToToggle._c_support_ensiavustus_extra_details], 'hidden', false)
				} else {
					// hidden
					this.$set(this.formSchema.fields[fieldsToToggle.c_agerange], 'hidden', true)
					this.$set(this.formSchema.fields[fieldsToToggle.c_illness_date], 'hidden', true)
					this.$set(this.formSchema.fields[fieldsToToggle._c_support_ensiavustus_extra_details], 'hidden', true)
					// visible
					this.$set(this.formSchema.fields[fieldsToToggle.startdate], 'hidden', false)
					this.$set(this.formSchema.fields[fieldsToToggle.enddate], 'hidden', false)
					this.$set(this.formSchema.fields[fieldsToToggle._c_support_hoitokorvaus_extra_details], 'hidden', false)
				}
			},
			deep: true,
		},

	},

	mounted () {
		this.formSchema = JSON.parse(JSON.stringify(this.config.forms.compensationApplication))
		this.ready = true // what is this for?
	},

	methods: {
		save () {
			this.formLoading = true

			this.$api.Me.doRequest({
				url: 'compensation',
				method: 'POST',
				body: this.formData,
			}).on('done', (res) => {
				if (res.body.error) return

				const parentRoute = this.$route.matched[this.$route.matched.length - 2]
				this.$router.replace(parentRoute)
			}).on('finish', () => {
				this.formLoading = false
			})
		},
	},
}

</script>
